export class QuestionnaireAnswerLine {
    questionNumber: string
    answerValue: string
}
